export default __webpack_public_path__ + "static/media/541.f2efd154.gif";